import {
  catalogColombiaIdeamArchive,
  checkColombiaWeatherSourceHealth,
  ingestColombiaSiataLayers,
  refreshColombiaRainViewerCache,
  runColombiaIdeamDiscovery,
  runColombiaSiataDiscovery,
  runColombiaAerocivilDiscovery,
  runColombiaAerocivilCacheSync,
} from "../../../../../weather/colombiaWeatherSourceHealthApi";
import {
  getSourceActions,
  getWeatherSourceActionMetadata,
  getWeatherSourceAdminActionsPlaceholder,
} from "../../../../../weather/weatherSourceActionRegistry";

async function runAction(action, sourceKey) {
  switch (action) {
    case "check-health":
      return checkColombiaWeatherSourceHealth(sourceKey);
    case "rainviewer-refresh":
      return refreshColombiaRainViewerCache();
    case "ideam-discovery":
      return runColombiaIdeamDiscovery(sourceKey);
    case "ideam-archive-catalog":
      return catalogColombiaIdeamArchive({ lookbackDays: 3, maxFilesTotal: 100 });
    case "siata-discovery":
      return runColombiaSiataDiscovery();
    case "siata-ingest":
      return ingestColombiaSiataLayers();
    case "aerocivil-discovery":
      return runColombiaAerocivilDiscovery();
    case "aerocivil-cache-sync":
      return runColombiaAerocivilCacheSync();
    default:
      throw new Error(`Unsupported action: ${action}`);
  }
}

const WeatherSourceActionButtons = ({
  sourceKey,
  canManage,
  runningAction,
  onActionStart,
  onActionComplete,
  onActionError,
}) => {
  const actions = getSourceActions(sourceKey);
  const placeholder = getWeatherSourceAdminActionsPlaceholder(sourceKey);

  if (!canManage) {
    return <p className="weather-source-detail__empty">Manage permission required for actions.</p>;
  }

  if (!actions.length) {
    return (
      <div className="weather-source-actions weather-source-actions--empty">
        <p className="weather-source-detail__empty">{placeholder?.title}</p>
        {placeholder?.message ? (
          <p className="weather-source-detail__message">{placeholder.message}</p>
        ) : null}
        {placeholder?.scripts?.length ? (
          <ul className="weather-source-actions__scripts">
            {placeholder.scripts.map((script) => (
              <li key={script}>
                <code>{script}</code>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    );
  }

  return (
    <div className="weather-source-actions">
      {actions.map((action) => {
        const metadata = getWeatherSourceActionMetadata(action);
        const isRunning = runningAction === action;
        const isDisabled = Boolean(runningAction);

        return (
          <div key={action} className="weather-source-actions__item">
            <button
              type="button"
              className="admin-dashboard__action-btn admin-dashboard__action-btn--small"
              disabled={isDisabled}
              title={metadata?.description || action}
              onClick={async () => {
                onActionStart(action);
                try {
                  const result = await runAction(action, sourceKey);
                  onActionComplete(result);
                } catch (error) {
                  onActionError(error);
                }
              }}
            >
              {isRunning ? "Running…" : metadata?.label || action}
            </button>
            {metadata?.description ? (
              <p className="weather-source-actions__description">{metadata.description}</p>
            ) : null}
            <span className="weather-source-actions__key">{action}</span>
          </div>
        );
      })}
    </div>
  );
};

export default WeatherSourceActionButtons;
